import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import ImageLoader from 'react-load-image';
import ReactLoading from 'react-loading';

import dollars from '../utils/dollars';
import { buildHandleEnterKeyPress } from '../utils/accessibility';

const defaultPhoneImage = require('../routes/device/images/default_phone.png');
const defaultTabletImage = require('../routes/device/images/default_tablet.png');
const defaultTVImage = require('../routes/device/images/default_tv.png');
const defaultFixedWirelessImage = require('../routes/device/images/hand-fixed-wireless-device.png');

const Preloader = props => (
  <ReactLoading color={props.theme.primary} type={'bubbles'} />
);
const Error = () => <div />;

const deviceImagesByType = {
  phone: defaultPhoneImage,
  tablet: defaultTabletImage,
  tv: defaultTVImage,
  'fixed wireless device': defaultFixedWirelessImage,
};

const getDeviceImageSource = (device, type, selectedColor) => {
  const { colors = [] } = device;

  let color = colors.find(c => c.name === selectedColor);

  return (
    (color && color.url) ||
    (device.defaultImage && device.defaultImage.url) ||
    deviceImagesByType[type] ||
    defaultTabletImage
  );
};

const DeviceBreakdown = ({
  device,
  deviceColor,
  deviceType,
  disableDelete,
  groupPays,
  issues,
  issueOptions,
  onDelete,
  prices,
  theme,
}) => (
  <BreakdownContainer>
    <ImageLoader src={getDeviceImageSource(device, deviceType, deviceColor)}>
      <img alt={`${deviceColor} ${deviceType}`} className="icon-image" />
      <Error />
      <Preloader theme={theme} />
    </ImageLoader>

    <div className="text-container">
      <div className="device-text">
        {[
          `${device.name || "You haven't selected a device yet"}`,
          `${deviceColor ? `- ${deviceColor}` : ''}`,
        ].join(' ')}
      </div>

      {issues.map((issue, i) => (
        <div className="price-container" key={`${issue}-${i}`}>
          <div className="price-label">{issue.displayName}</div>

          {!groupPays && (
            <div className="price-value">
              {dollars(prices[issue.name] / 100 || 0)}
            </div>
          )}
        </div>
      ))}
    </div>

    <div
      className="deletecontainer"
      onClick={(...args) => !disableDelete && onDelete(...args)}
      onKeyPress={(...args) =>
        !disableDelete && buildHandleEnterKeyPress(onDelete(...args))
      }
      tabIndex={disableDelete ? -1 : 0}
    >
      {!disableDelete && (
        <img alt="Close X" className="delete" src={require('./close-x.png')} />
      )}
    </div>
  </BreakdownContainer>
);

DeviceBreakdown.propTypes = {
  device: PropTypes.object,
  deviceColor: PropTypes.string,
  deviceType: PropTypes.string,
  disableDelete: PropTypes.bool,
  issueOptions: PropTypes.array.isRequired,
  issues: PropTypes.array,
  onDelete: PropTypes.func,
  prices: PropTypes.object,
};

DeviceBreakdown.defaultProps = {
  device: { colors: [] },
  deviceColor: '',
  deviceType: '',
  disableDelete: false,
  issues: [],
  onDelete: () => {},
  prices: {},
};

const BreakdownContainer = styled.div`
  align-items: flex-start;
  border-bottom: ${props => `1px solid ${props.theme.border}`};
  display: flex;
  flex-direction: row;
  font-size: 80%;
  justify-content: flex-start;
  padding: 1em 0.25em;

  .delete {
    height: 15px;
    top: 0;
    width: 15px;
  }
  .delete-container {
    cursor: pointer;
    height: 100%;
    padding: 5px;
  }
  .device-text {
    color: ${props => props.theme.subText};
    margin: 0 0 0.5em 0;
  }
  .icon-image {
    height: auto;
    margin: 0 1em 0 0;
    width: 45px;
  }
  .price-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 1em 0;
    width: 100%;
  }
  .price-label {
    color: black;
  }
  .price-value {
    color: black;
    text-align: right;
  }
  .text-container {
    width: 100%;
  }
`;

export default withTheme(DeviceBreakdown);
